import { v4 as uuidv4 } from 'uuid';
import {
    FETCH_COMMENTS_AND_GIST_START,
    FETCH_COMMENTS_AND_GIST_SUCCESS,
    FETCH_COMMENTS_AND_GIST_FAIL,

} from "../../../constants";
import {
    FETCH_COMMENTS_AND_GIST_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

// `scope` — { categoryName, subCategoryName, behaviorText } — is passed only
// when this is triggered by the Sample Comments Category/Sub-Category/
// Behavior dropdowns, not the page-level filter fetch. Every call gets a
// fresh requestId so the reducer can drop a response that resolves after a
// newer request has already been dispatched.
export const getCommentsAndGist = (payload, cb, scope) => {
    const requestId = uuidv4();
    const isScopeFetch = !!scope;
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_COMMENTS_AND_GIST_START, { requestId, isScopeFetch })
        );
        return apiBaseInstance
            .post(FETCH_COMMENTS_AND_GIST_URL, {
                benchmarkFilters: payload,
                ...getProjectIdAndOrgId(payload),
                currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR,
                ...(scope || {}),
                requestId,
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_COMMENTS_AND_GIST_SUCCESS, {
                        data: res.data,
                        requestId,
                        isScopeFetch,
                    })
                );
                cb && cb(true, res.data)
            })
            .catch((err) => {
                dispatch(withType(FETCH_COMMENTS_AND_GIST_FAIL, { ...err, requestId, isScopeFetch }));
                cb && cb(false)
            });
    };
};
